// removing bubble toggle
function bubbleToggle() {
  // console.log('bubbleToggle: ');
  const cartBubble = document.querySelector('.cart-count-bubble');
  if (cartBubble) {
    const cartBubbleNumber = document.getElementById('cart-bubble-number').innerText;
    // console.log('cartBubble: ', cartBubbleNumber);
    if (cartBubbleNumber > 0) {
      cartBubble.classList.add('tw-opacity-100');
      cartBubble.classList.remove('tw-opacity-0');
    }
  } else {
    console.log('cartBubble not found');
  }
}
document.addEventListener('DOMContentLoaded', () => {
  bubbleToggle();
});